export const INVOICE_LOAD_SUCCEED = '@@mah-maps/INVOICE_LOAD_SUCCEED';
export const INVOICE_LOAD_FAILED = '@@mah-maps/INVOICE_LOAD_FAILED';